function Products() {
	return ( 
		<div>
			<p>Not ready yet....</p>
		</div>
	);
}

export default Products;